// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__LZiqB","dragIcon":"Choice_dragIcon__1RjzJ","left":"Choice_left__13RCu","input":"Choice_input__2g7lt"};